((ProductUpsell, $) => {
  'use strict';

  const sliderOptions = {
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    mobileFirst: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: 'unslick'
      }
    ]
  };
  const flGreen = '#80d93d';
  const defaultTitle = 'Other products you may be interested in';

  let $window;
  let $productUpsell;
  let $close;
  let $overlay;
  let $submit;
  let $addToCart;
  let $insertionPoint;
  let shopUrl;
  let $upsellTitle;

  const cacheDom = () => {
    $window = $(window);
    $productUpsell = $('.js-product-upsell');
    $close = $productUpsell.find('.js-product-upsell-close');
    $overlay = $productUpsell.find('.js-product-upsell-overlay');
    $submit = $productUpsell.find('.js-product-upsell-button');
    $insertionPoint = $productUpsell.find('.js-product-insertion');
    $upsellTitle = $productUpsell.find('.js-product-upsell-title');
    $addToCart = $('[data-add-to-cart]');
  };

  const variableSetup = (url) => {
    shopUrl = url;
  };

  const showAdded = ($this) => {
    $this.text('Added!')
      .attr('disabled', 'disabled')
      .css({
        'background-image': 'none',
        'background-color': flGreen,
        cursor: 'default'
      });
  };

  const createSlider = () => {
    $('.js-upsell-slider').slick(sliderOptions);
  };

  const setCookie = () => {
    const amountOfMinutes = 5;
    const minutesFromNow = new Date(new Date().getTime() + amountOfMinutes * 60 * 1000);
    window.Cookies.set('BVAUpsell', 'true', {
      expires: minutesFromNow
    });
  };

  const open = (collectionHandle) => {
    let collectionExists = false;
    $.get(`/collections/${collectionHandle}?view=product-upsell`, (response) => {
      if (response.indexOf('js-product-upsell--product') >= 0) {
        $insertionPoint.html(response);
        collectionExists = true;
      }
    }).done(() => {
      if (collectionExists) {
        let hasCollection = false;
        if (window.collectionsInCart) {
          for (let i = 0; i < window.collectionsInCart.length; i++) {
            if (collectionHandle === window.collectionsInCart[i]) {
              hasCollection = true;
              break;
            }
          }
        }
        if (!hasCollection) {
          $productUpsell.find('.grid-item > a').removeAttr('href');
          $productUpsell.find('.grid-meta > a').removeAttr('href');
          window.TileReviews.run(shopUrl, $('.js-product-upsell .grid-meta'));
          if (window.GeolizrAPI && window.GeolizrAPI.api) {
            window.GeolizrAPI.api.switchCurrency(window.GeolizrAPI.api.getCurrency());
          }
          $productUpsell.removeClass('product-upsell-hidden');
          createSlider();
          window.Scroll.lock();
          setCookie();
        } else {
          window.InlineCart.triggerInlineCart();
          window.Scroll.lock();
        }
      } else {
        window.InlineCart.triggerInlineCart();
        window.Scroll.lock();
      }
    });
  };

  const close = (event) => {
    event.preventDefault();
    $productUpsell.addClass('product-upsell-hidden');
    $submit.text('No Thanks').removeClass('product-upsell-button--item-added');
    window.InlineCart.triggerInlineCart();
  };

  const bindUIActions = () => {
    $close.on('click', close);
    $overlay.on('click', close);
    $submit.on('click', close);

    $(document).on('click', '[data-add-to-cart]', function () {
      const $this = $(this);
      const collectionHandle = $this.attr('data-product-upsell-collection-handle');
      const title = $this.attr('data-product-upsell-title');

      if (title) {
        $upsellTitle.text(title);
      } else {
        $upsellTitle.text(defaultTitle);
      }

      if (window.Cookies.get('BVAUpsell') && $productUpsell.hasClass('product-upsell-hidden')) {
        window.InlineCart.triggerInlineCart();
        window.Scroll.lock();
      } else if (!collectionHandle && $productUpsell.hasClass('product-upsell-hidden')) {
        window.InlineCart.triggerInlineCart();
        window.Scroll.lock();
      } else {
        open(collectionHandle);
      }
    });

    $productUpsell.on('click', '[data-add-to-cart]', function addUpsellItemToCart() {
      const $this = $(this);
      const variantId = $this.attr('data-variant-id');
      const quantity = 1;
      const description = $this.attr('data-hover-text');

      window.CartJS.addItem(variantId, quantity, {
        description
      }, {
        success: () => {
          showAdded($this);

          if (!$submit.hasClass('product-upsell-button--item-added')) {
            $submit.text('Proceed to Cart').addClass('product-upsell-button--item-added');
          }
        },
        error: () => {
          close();
        }
      });

      showAdded($this);
    });

    $window.on('resize', function onResize() {
      const $this = $(this);
      const $slider = $('.js-upsell-slider');
      if (!$productUpsell.hasClass('product-upsell-hidden') &&
        $this.width() <= 992 &&
        !$slider.hasClass('slick-initialized'
      )) {
        $slider.slick(sliderOptions);
      }
    });
  };

  const init = (url) => {
    cacheDom();
    variableSetup(url);
    bindUIActions();
  };

  ProductUpsell.init = init;
  ProductUpsell.open = open;

  ProductUpsell.defaultTitle = defaultTitle;
})(window.ProductUpsell = window.ProductUpsell || {}, jQuery);
